/**
 * publicData key that controls search-engine indexing of a user profile page.
 * Missing value means indexable (default true). Set to false in Console to opt out.
 */
export const SEARCH_ENGINE_INDEX_PUBLIC_DATA_KEY = 'searchEngineIndex';

/**
 * Whether user profile pages should be indexed marketplace-wide.
 * Default is enabled when the env var / config value is unset.
 */
export const isUserProfileIndexingGloballyEnabled = config => {
  if (config && typeof config.indexUserProfiles === 'boolean') {
    return config.indexUserProfiles;
  }
  return process.env.REACT_APP_INDEX_USER_PROFILES !== 'false';
};

/**
 * Whether a specific user profile should be indexed.
 * @param {Object} user Sharetribe user resource
 * @param {Object} [config] marketplace config
 * @returns {boolean}
 */
export const isUserProfileIndexable = (user, config) => {
  if (!isUserProfileIndexingGloballyEnabled(config)) {
    return false;
  }
  if (!user?.id || user.attributes?.deleted || user.attributes?.banned) {
    return false;
  }
  if (user.attributes?.state && user.attributes.state !== 'active') {
    return false;
  }

  const flag = user.attributes?.profile?.publicData?.[SEARCH_ENGINE_INDEX_PUBLIC_DATA_KEY];
  return flag !== false;
};
